export const convertJSONintoPreferredTryOutFormat = (method) =>{
  const Headers = [...method.headers];

  Headers.push({"name": "api-key"});

  // Check if request body exists and has a content type
  const RequestBody = method.requestBody;
  if (RequestBody && RequestBody.content) {
    // Check for application/json or multipart content type
    const contentType = Object.keys(RequestBody.content).find((key) =>
      key.toLowerCase().includes("json") || key.toLowerCase().includes("multipart"),
    );

    if (contentType) {
      // Add Content-Type header based on the content type
      Headers.push({
        name: "Content-type",
        in: "header",
        required: true,
        schema: {type: "string"},
        value: contentType,
      });
    }
  }
  const def={
    name: "Accept",
  };
  Headers.push(def);
  const PathParameters = method.parameters.filter((item)=>item.in==="path")
    .map((item)=>{
      const {name, in: In, required, schema: {type}} = item;
      return {
        name,
        in: In,
        type,
        required: required.toString(),
      };
    });
  const QueryParameters = method.parameters.filter((item)=> item.in ==="query")
    .map((item)=>{
      const {name, in: In, required, schema: {type}} = item;
      return {
        name,
        in: In,
        type,
        required: required.toString(),
      };
    });
  return {
    Headers, PathParameters, QueryParameters, RequestBody,
  };
};

